/**
 * Note: there is a relation to MBCCState. Only values which are part of ContextProperty enum will be updated in store.
 */
export enum RuntimeVariables {
  BackendUrl = 'backendUrl',
  CarlUrl = 'carlUrl',
  CarlLabel = 'carlLabel',
  FcisEnvironment = 'fcisEnvironment',
  Subprocess = 'subprocess',
  Country = 'country',
  Language = 'language',
  VehicleClass = 'vehicleClass',
  VehicleBody = 'vehicleBody',
  VehicleId = 'vehicleId',
  ExternalId = 'externlId',
  FinancialCode = 'financialCode',
  Healed = 'healed',
  Baumuster = 'baumuster',
  VcsId = 'vcsId',
  Nst = 'nst',
  UserChooser = 'userChooser',
  FormattingTag = 'formattingTag',

  // Retailer specific
  CompanyId = 'companyId',
  DealerGroup = 'dealerGroup',
  GsOutletId = 'gsOutletId',
  AllGsOutletIds = 'allGsOutletIds'
}
